import { useEffect, useState } from 'react'
import CrudPage from '../../components/CrudPage'
import { cotizacionesCrud, monedasApi } from '../../api/entities'
import { idOf } from '../../api/crud'

// ABM Cotizaciones (tipo de cambio del día). Lectura: GET /cotizacionmonedas?view=BaseList.
// VALIDADO EN VIVO contra el MT (2026-06-25, admin_fvv):
//   ALTA  POST /cotizacionmonedas { monedaDesde:{id}, monedaHasta:{id}, fecha:'yyyy/MM/dd',
//          valorCompra, valorVenta } -> HTTP 200 (verificado: persiste id 127, dolares->guaranies).
//   EDICIÓN PUT /cotizacionmonedas/{id} (mismo payload, id en URL) -> HTTP 200.
//   La fecha DEBE ir con barras (yyyy/MM/dd); el GET la devuelve igual con barras.
export default function CotizacionesPage() {
  const [monedas, setMonedas] = useState([])
  useEffect(() => { monedasApi.listar().then(setMonedas).catch(() => {}) }, [])
  const optMoneda = (o) => o?.descripcion || o?.codigo

  return (
    <CrudPage
      title="Cotizaciones"
      api={cotizacionesCrud}
      searchable={false}
      columns={[
        { key: 'monedaDesde.codigo', label: 'Desde' },
        { key: 'monedaHasta.codigo', label: 'A' },
        { key: 'fecha', label: 'Fecha' },
        { key: 'valorCompra', label: 'Compra', align: 'right' },
        { key: 'valorVenta', label: 'Venta', align: 'right' },
      ]}
      fields={[
        { name: 'monedaDesde', label: 'Moneda', type: 'select', options: monedas, optionLabel: optMoneda, required: true },
        { name: 'monedaHasta', label: 'A moneda', type: 'select', options: monedas, optionLabel: optMoneda, required: true },
        { name: 'fecha', label: 'Fecha', type: 'date', required: true },
        { name: 'valorCompra', label: 'Valor compra', type: 'number' },
        { name: 'valorVenta', label: 'Valor venta', type: 'number', required: true },
      ]}
      toPayload={(f) => ({
        monedaDesde: idOf(f.monedaDesde),
        monedaHasta: idOf(f.monedaHasta),
        fecha: (f.fecha || '').replace(/-/g, '/'),
        valorCompra: Number(f.valorCompra) || 0,
        valorVenta: Number(f.valorVenta) || 0,
      })}
      fromEntity={(e) => ({
        monedaDesde: e.monedaDesde,
        monedaHasta: e.monedaHasta,
        fecha: (e.fecha || '').replace(/\//g, '-').slice(0, 10),
        valorCompra: e.valorCompra,
        valorVenta: e.valorVenta,
      })}
    />
  )
}
